import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {UrlService} from 'shared/services/url.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LandingPageComponent implements OnInit {
  versions: Version[];
  version = '';
  env = environment;
  selectedVersionUrl = '/home';
  isRetained: boolean;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly urlService: UrlService
  ) {}

  ngOnInit(): void {
    this.selectOverview();
    this.isRetained = this.env.isRetained === 'true';

    this.route.queryParams.subscribe(params => {
      const lang = params.lang;
      if (lang) {
        this.translate.use(lang);
      }
    });
  }

  selectionChange(value: string) {
    const href = this.getCurrentHref();
    let url = href.endsWith('/') ? href : `${href}/`;

    if (url.includes('cfap02.atlantica.admin.ch')) {
      url = this.env.uiRoute.replace('version', value);
    }
    if (url.includes('logib.legacy.admin.ch')) {
      url = `${url}${value}`;
    }

    this.selectedVersionUrl = `${url}home`;
  }

  selectOverview() {
    const arrayOptions = this.env.applicationVersions;
    this.versions = [];

    const items = arrayOptions.split(',');
    items.forEach(item => {
      const option = item.split('|');
      this.versions.push(new Version(option[0], option[1]));
    });
  }

  getLogsysUrl(): string {
    return this.urlService.getLogsysUrl();
  }

  private getCurrentHref(): string {
    return window.location.href;
  }
}

class Version {
  public value: string;
  public caption: string;
  constructor(value: string, caption: string) {
    this.value = value;
    this.caption = caption;
  }
}
